import { SingleRowTableProps } from '../interface/interface';

export const SingleRowTable = ({
  headers,
  values,
  tableWidth,
  headerBgColor,
}: SingleRowTableProps) => {
  return (
    <div className="overflow-x-auto">
      <table
        className={`${tableWidth} border-collapse border hidden md:table shadow-sm`}
      >
        <thead>
          <tr className={`${headerBgColor} text-white`}>
            {headers.map((header, index) => (
              <th
                key={index}
                className="text-xs font-semibold py-2 px-4 border"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {values.map((row, rowIndex) => (
            <tr key={rowIndex} className="text-center">
              {row.map((value, colIndex) => (
                <td
                  key={colIndex}
                  className="text-xs font-regular py-2 px-4 border"
                >
                  {value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {/* Mobile View */}
      <div className="md:hidden">
        {values.map((row, rowIndex) => (
          <div
            key={rowIndex}
            className="border border-secondary-cornflowerblue-100 mb-4 rounded-lg"
          >
            {row.map((value, colIndex) => (
              <div
                key={colIndex}
                className="flex justify-between border-b border-secondary-cornflowerblue-100 p-2"
              >
                <span className="font-semibold text-sm text-primary-blue-500">
                  {headers[colIndex]}:
                </span>
                <span className="text-sm font-regular text-primary-blue-500">
                  {value}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleRowTable;
